import { CreateCustomer } from '../../../domain/customers/createCustomer';
import { UpdateCustomer } from '../../../domain/customers/updateCustomer';
import { CustomerAdapter } from '../../adapters/customers/customersAdapters';
import { CustomerDTO } from '../../http/dtos/customers/customerDTO';
import { CustomerSelectorDTO } from '../../http/dtos/customers/customerSelectorDTO';

import httpClient from '../../http/httpClient';

export const CustomersRepository = {
    GetCustomersListSelector: () => {
        return httpClient
            .get('/customers')
            .then((response: CustomerSelectorDTO[]) => response);
    },

    GetCustomersList: () => {
        return httpClient
            .get('/customers/customers-list')
            .then((response: CustomerDTO[]) =>
                CustomerAdapter.getCustomerListAdapter(response)
            );
    },

    GetCustomer: (id: string) => {
        return httpClient
            .get('/customers/customer-by-id/' + id)
            .then((response: CustomerDTO) =>
                CustomerAdapter.getCustomerAdapter(response)
            );
    },

    CreateCustomer: (newCustomer: CreateCustomer) => {
        return httpClient
            .post('/customers/create-customer', newCustomer)
            .then((response) => response);
    },

    UpdateCustomer: (newCustomer: UpdateCustomer, id: number) => {
        return httpClient
            .put('/customers/update-customer/' + id, newCustomer)
            .then((response) => response);
    },
};
